goog.provide("shadow.js.shim.module$$mui$material$TextField");
goog.provide("module$shadow_js_shim_module$$mui$material$TextField");
shadow.js.shim.module$$mui$material$TextField = shadow.js.nativeProvides["@mui/material/TextField"] = shadow$bridge("@mui/material/TextField");
module$shadow_js_shim_module$$mui$material$TextField.default = shadow.js.shim.module$$mui$material$TextField;
